import React, { Suspense } from "react";
import { Footer, Navbar } from "./Components/Molecule";
import { Route, Routes } from "react-router-dom";
import { PageRoutes } from "./Routes";
import "aos/dist/aos.css";
//Toastify
import { ToastContainer } from "react-toastify";
import PageLoader from "./Components/PageLoader";
function App() {
  return (
    <div>
      <Navbar />
      <ToastContainer />

      <div className="app">
        <Suspense fallback={<PageLoader />}>
          <Routes>
            {PageRoutes.map((item, index) => (
              <Route
                key={index}
                path={item.path}
                element={<item.component />}
              />
            ))}
          </Routes>
        </Suspense>
      </div>

      <Footer />
    </div>
  );
}


export default App;
